$(".menu-web-link").click(function (e) {
    e.preventDefault();
    $(".menu-web-target").toggleClass("toggled");
});
$(".menu-mobile-link").click(function (e) {
    e.preventDefault();
    $(".menu-mobile-target").toggleClass("toggled");
});